// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storage_DeleteBucketModal_text__j4LR6 {
  color: var(--color-black);
  font-size: 14px;
  line-height: 1.4;
}

.storage_DeleteBucketModal_controls__ezJbV > * {
  flex: 1 1;
}
`, "",{"version":3,"sources":["webpack://./src/containers/BucketsPageContent/modals/DeleteBucketModal/DeleteBucketModal.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT","sourcesContent":[".text {\n  color: var(--color-black);\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.controls > * {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `storage_DeleteBucketModal_text__j4LR6`,
	"controls": `storage_DeleteBucketModal_controls__ezJbV`
};
export default ___CSS_LOADER_EXPORT___;
